<div class="flex flex-col">
  <a *lohiFeatureFlag="'superhighwayBanner'">
    <div
      style="background-image: url(assets/images/super-highway-banner.png)"
      class="flex md:flex-row flex-col justify-between m-1 lg:mx-3 lg:mt-3 bg-cover cursor-pointer"
      [routerLink]="['/superhighway']"
    >
      <div class="flex md:flex-row flex-col my-2 md:my-4 items-center">
        <div class="text-xl font-semibold px-4 md:px-6 items-center md:items-start md:mr-4 flex flex-col">
          <span class="text-blue-400 mb-1 text-center md:text-left">Haul More Payloads to Earn Up to 17% More</span>
          <span class="text-white text-center md:text-left leading-normal"
            >Register your drivers as 5F SuperDrivers to keep rolling on slow days! Haul Grain, Cement, Chemicals, and
            other payloads in addition to Sand.</span
          >
        </div>
      </div>
      <div
        class="flex flex-col items-center justify-center pl-5 pr-3 gap-y-2 md:flex hidden"
        style="background-color: #08a9e9; clip-path: polygon(23% 0, 100% 0, 100% 100%, 0 100%)"
      >
        <span class="text-2xl text-white font-bold w-25 text-center">Register Now</span>
      </div>
      <div
        class="flex flex-col items-center justify-center px-2 py-2 gap-y-2 block md:hidden"
        style="background-color: #08a9e9"
      >
        <span class="text-2xl text-white font-bold w-25 text-center">Register Now</span>
      </div>
    </div>
  </a>

  <div class="flex flex-col md:flex-row p-1 lg:p-3 grid md:grid-cols-4 md:gap-x-4">
    <ng-container *ngIf="finesAndFees$ | async as finesAndFees">
      <a
        [routerLink]="['/settlement', 'details', finesAndFees.lastSettlementId]"
        class="md:col-span-4 p-2 bg-red-500 font-semibold text-white mb-2"
        *ngIf="finesAndFees?.trailerFees?.chargeCount + finesAndFees?.shiftFees?.chargeCount > 0"
      >
        You have been penalized
        {{
          finesAndFees?.trailerFees?.totalCostInCents + finesAndFees?.shiftFees?.totalCostInCents | currencyInPennies
        }}
        on your most recent settlement for
        <ng-container *ngIf="finesAndFees?.trailerFees?.chargeCount">
          {{ finesAndFees?.trailerFees?.chargeCount }} Unreturned Trailers
        </ng-container>
        <ng-container *ngIf="finesAndFees?.shiftFees?.chargeCount">
          {{ finesAndFees?.shiftFees?.chargeCount }} Driver's Shifts Skipped
        </ng-container>
      </a>
    </ng-container>
    <div class="flex flex-col flex-1 mt-1 md:col-span-3">
      <span class="text-gray-900 text-2xl font-bold mb-2">Demand</span>
      <div class="card-with-shadow flex flex-col bg-white rounded mb-6 h-35 md:h-75">
        <ng-container *ngIf="todayDemand$ | async as todayDemands">
          <lohi-driver-demand-map class="flex-1" [regionsWithDemand]="todayDemands"></lohi-driver-demand-map>
        </ng-container>
      </div>
      <div class="flex flex-col lg:flex-row gap-x-3 gap-y-2 mb-6">
        <ng-container *ngIf="stats$ | async as stats">
          <div
            class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600 flex-1 cursor-pointer"
            [routerLink]="['../kpis']"
          >
            <div class="flex flex-col p-2 border-b border-gray-300">
              <div class="flex flex-row mb-1">
                <span class="text-lg text-gray-900 font-semibold mr-1">Revenue</span>
                <span class="text-sm text-gray-500">(Past 30 days)</span>
              </div>
              <span class="text-gray-900 text-5xl font-semibold leading-none">{{
                stats.pastRevenue | currencyInPennies: 'USD':'symbol':'1.0-0'
              }}</span>
            </div>
            <div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
              <span class="material-icons text-base mr-1">arrow_forward</span>
              <span>View KPIs</span>
            </div>
          </div>
          <div
            class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600 flex-1 cursor-pointer"
            [routerLink]="['../settlement/list']"
          >
            <div class="flex flex-col p-2 border-b border-gray-300">
              <div class="flex flex-row mb-1">
                <span class="text-lg text-gray-900 font-semibold mr-1">Previous Settlement</span>
              </div>
              <span class="text-gray-900 text-5xl font-semibold leading-none">{{
                stats.lastSettlement | currencyInPennies: 'USD':'symbol':'1.0-0'
              }}</span>
            </div>
            <div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
              <span class="material-icons text-base mr-1">arrow_forward</span>
              <span>View Settlements</span>
            </div>
          </div>
          <div
            class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600 flex-1 cursor-pointer"
            [routerLink]="['../loads/list/completed']"
          >
            <div class="flex flex-col p-2 border-b border-gray-300">
              <div class="flex flex-row mb-1">
                <span class="text-lg text-gray-900 font-semibold mr-1">Loads Needing Audit</span>
              </div>
              <span class="text-gray-900 text-5xl font-semibold leading-none">{{ stats.loadsNeedAuditing }}</span>
            </div>
            <div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
              <span class="material-icons text-base mr-1">arrow_forward</span>
              <span>View Completed Loads</span>
            </div>
          </div>
        </ng-container>
        <!--    TODO else loading-->
      </div>
      <div class="flex flex-col md:flex-row gap-x-3 mb-6">
        <div class="flex flex-col flex-1">
          <div class="flex flex-row py-1 items-center">
            <span class="text-gray-900 text-xl font-bold mr-1">Your Drivers</span>
            <div>
              <button mat-icon-button (click)="toggleTierNotification()" tooltip="Toggle Driver Tier Notifications">
                <mat-icon [class.text-blue-600]="(tierDropsEnabled$ | async)?.enabled">
                  {{ (tierDropsEnabled$ | async)?.enabled ? 'notifications' : 'notifications_off' }}
                </mat-icon>
              </button>
            </div>
            <!--<ng-container *ngIf="tierNotificationOn$$ | async; else notificationOff">
              <span
                class="material-icons text-blue-500 cursor-pointer"
                matTooltip="Turn Notification Off"
                (click)="toggleNotification()"
                [matTooltipPosition]="'above'"
                >notifications_active</span
              >
            </ng-container>
            <ng-template #notificationOff>
              <span
                class="material-icons text-gray-500 cursor-pointer"
                (click)="toggleNotification()"
                matTooltip="Turn Notification On"
                [matTooltipPosition]="'above'"
                >notifications_off</span
              >
            </ng-template>-->
          </div>
          <div class="card-with-shadow flex flex-col bg-white rounded overflow-y-auto h-35 md:h-75">
            <ng-container *ngIf="tierFeeds$ | async as tierFeedsDate">
              <div class="flex-row flex py-3 px-2 justify-between">
                <div
                  class="flex flex-col gap-y-1 items-center"
                  *ngFor="let tier of tierFeedsDate.tierDiverCount; trackBy: 'id' | trackByKey"
                >
                  <span class="font-semibold text-xs text-gray-500">{{ tier.numberOfDrivers }}</span>
                  <img src="{{ getTierImage(tier.tierId) }}" class="w-3" />
                  <span class="font-bold" [style]="{ color: getTierColor(tier.tierId) }"
                    >{{ tier.driverTakeRate }} %</span
                  >
                </div>
              </div>
              <div class="flex flex-col">
                <div *ngFor="let feed of tierFeedsDate.driverTierFeeds; trackBy: 'id' | trackByKey">
                  <ng-container *ngIf="feed.isDemoted; else normalFeed">
                    <div class="flex flex-col border-t border-gray-300 p-2" style="background: rgba(240, 79, 15, 0.07)">
                      <div class="text-gray-900">
                        <span class="font-bold cursor-pointer" [routerLink]="['../drivers', feed.userId, 'profile']">{{
                          feed.username
                        }}</span>
                        got demoted for {{ feed.shortReason }}
                      </div>
                      <span class="text-xs text-gray-600">{{ feed.createdAt | ago }}</span>
                    </div>
                  </ng-container>
                  <ng-template #normalFeed>
                    <div class="flex flex-col border-t border-gray-300 p-2">
                      <div class="text-gray-900">
                        <span class="font-bold cursor-pointer" [routerLink]="['../drivers', feed.userId, 'profile']">{{
                          feed.username
                        }}</span>
                        reached {{ feed.currentTierName }} Tier
                      </div>
                      <span class="text-xs text-gray-600">{{ feed.createdAt | ago }}</span>
                    </div>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="flex flex-col flex-1">
          <div class="card-with-shadow flex flex-col bg-white" style="margin-top: 36px">
            <ng-container *ngIf="driversHitchStats$ | async as driversHitchStats">
              <div class="flex flex-col border-b border-gray-300 p-3">
                <span class="text-lg font-bold text-gray-900 mb-4">Now ({{ driversHitchStats.drivers }} Drivers)</span>
                <div class="flex flex-row">
                  <div class="flex flex-1 flex-col border-gray-300 border-r pr-3 items-center">
                    <div class="text-gray-600 mb-1 font-medium leading-none">On Hitch</div>
                    <div class="text-6xl text-gray-900 font-bold mb-2 leading-none">
                      {{ driversHitchStats.onHitch }}
                    </div>
                    <div class="flex flex-row p-1 w-full justify-between text-gray-600">
                      <span>Excused Absences</span>
                      <span class="font-bold">{{ driversHitchStats.noShows }}</span>
                    </div>
                  </div>
                  <div class="flex flex-1 flex-col pl-3 items-center">
                    <div class="text-gray-600 mb-1 leading-none">Off Hitch</div>
                    <div class="text-6xl text-gray-900 mb-2 font-bold leading-none">
                      {{ driversHitchStats.offHitch }}
                    </div>
                    <div
                      class="flex flex-row p-1 rounded-sm w-full justify-between text-orange-500"
                      style="background: rgba(240, 79, 15, 0.1)"
                    >
                      <span class="font-medium">No Hitch Booked</span>
                      <span class="font-bold">{{ driversHitchStats.doesNotHaveFutureHitch }}</span>
                    </div>
                    <div class="flex flex-row p-1 w-full justify-between text-gray-600">
                      <span class="font-medium">On Hitch Later</span>
                      <span class="font-bold">{{ driversHitchStats.hasFutureHitch }}</span>
                    </div>
                  </div>
                </div>
                <!--              <div class="flex flex-row justify-between">-->
                <!--                <div class="flex flex-row items-center">-->
                <!--                  <span class="material-icons text-orange-500 mr-1 text-lg">warning</span>-->
                <!--                  <span class="font-bold text-gray-900 text-lg">About to Loose Tier:</span>-->
                <!--                </div>-->
                <!--                <span class="text-lg text-gray-900">{{ driversHitchStats.aboutToLooseTier }} Drivers</span>-->
                <!--              </div>-->
              </div>
              <div
                class="flex flex-row text-lg text-blue-500 py-3 items-center justify-center cursor-pointer"
                [routerLink]="['calendar']"
              >
                <span class="material-icons text-base mr-1">arrow_forward</span>
                <span>View Driver Calendar</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="flex flex-col" style="height: 1000px">
        <div class="flex flex-row justify-between mb-2">
          <span class="text-gray-900 text-xl font-bold">Newsfeed</span>
          <mat-select [formControl]="regionsFilterControl" style="width: 200px !important">
            <mat-option [value]="'all'">All Regions</mat-option>
            <mat-option
              [value]="region.beamerSegmentFilter"
              *ngFor="let region of regions$ | async; trackBy: 'id' | trackByKey"
            >
              {{ region.name }}
            </mat-option>
          </mat-select>
        </div>
        <div class="flex flex-col w-full flex-1 bg-white card-with-shadow">
          <ng-container *ngIf="safeNewsFeedUrl">
            <iframe
              class="card-with-shadow"
              width="100%"
              height="100%"
              [src]="safeNewsFeedUrl"
              style="position: absolute; top: -9999em; visibility: hidden"
              onload="this.style.position='static'; this.style.visibility='visible';"
            ></iframe>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="flex flex-col mt-1">
      <div
        class="flex flex-row cursor-pointer font-bold text-lg text-blue-500 text-lg mb-2 justify-end items-center"
        [routerLink]="['../billing']"
      >
        <span>Billing Export</span>
        <span class="material-icons text-base ml-1">arrow_forward</span>
      </div>

      <div class="card-with-shadow bg-white flex flex-col mb-6 h-35 md:h-75">
        <div class="flex flex-row justify-between items-center p-2">
          <span class="text-gray-900 text-lg font-bold">Alerts</span>
          <div class="hidden">
            <ng-container *ngIf="(clearingAllAlerts$$ | async) === false; else clearingAllAlerts">
              <div
                class="flex items-center rounded-full bg-gray-300 text-gray-600 px-1 cursor-pointer"
                (click)="clearAll()"
              >
                <span class="material-icons text-base">clear</span>
                <span class="text-sm">Clear All</span>
              </div>
            </ng-container>
            <ng-template #clearingAllAlerts>
              <mat-spinner diameter="16"></mat-spinner>
            </ng-template>
          </div>
        </div>
        <div class="flex flex-col overflow-y-auto h-full">
          <ng-container *ngIf="alerts$ | async as alerts">
            <ng-container *ngIf="alerts && alerts.length > 0; else noAlerts">
              <ng-container *ngFor="let alert of alerts; trackBy: 'id' | trackByKey">
                <ng-container [ngSwitch]="alert.type">
                  <div class="flex flex-row p-2 border-b border-gray-300 gap-x-1" *ngSwitchCase="'account'">
                    <img class="self-start mt-2" src="assets/images/notification.svg" />
                    <div class="flex flex-col flex-1">
                      <span class="text-gray-600 leading-normal" style="font-size: 10px">ACCOUNTING</span>
                      <div class="cursor-pointer" [routerLink]="['../loads/list/completed']">
                        You have <span class="text-blue-500">{{ alert.description.replace('You have', '') }}</span>
                      </div>
                    </div>
                    <span
                      class="material-icons text-gray-600 text-lg mt-2 cursor-pointer"
                      (click)="dismissNotificationLocally(alert.id)"
                      >clear</span
                    >
                  </div>
                  <div class="flex flex-row p-2 border-b border-gray-300 gap-x-1" *ngSwitchCase="'driver_performance'">
                    <img class="self-start mt-2" src="assets/images/notification.svg" />
                    <div class="flex flex-col flex-1">
                      <details>
                        <summary style="list-style: none">
                          <span class="text-gray-600 leading-normal" style="font-size: 10px">DRIVER PERFORMANCE</span>
                          <div class="cursor-pointer">
                            <span class="text-blue-500"
                              >{{ alert.description.replace('did not show up for their hitch', '') }} </span
                            >did not show up for their hitch
                          </div>
                          <span class="text-gray-600 text-sm">{{ alert.createdAt | ago }}</span>
                        </summary>
                        <div class="mt-1 flex flex-col">
                          <div
                            class="flex flex-row text-sm justify-between"
                            *ngFor="let user of alert.noShowUsers; trackBy: 'name' | trackByKey"
                          >
                            <span class="text-gray-600 cursor-pointer" (click)="redirectToDriverScorecard(user.id)">{{
                              user.name
                            }}</span>
                            <span class="text-blue-500">{{ user.phone | phone }}</span>
                          </div>
                        </div>
                      </details>
                    </div>
                    <span
                      class="material-icons text-gray-600 text-lg mt-2 cursor-pointer"
                      *ngIf="!alert.dismissing; else dismissing"
                      (click)="alert.dismissing = true; dismissNotification([alert.id])"
                      >clear</span
                    >
                    <ng-template #dismissing>
                      <span class="mt-2">
                        <mat-spinner diameter="16" [color]="'primary'"></mat-spinner>
                      </span>
                    </ng-template>
                  </div>
                  <ng-container *lohiFeatureFlag="'penaltyAlerts'">
                    <div class="flex flex-row p-2 border-b border-gray-300 gap-x-1" *ngSwitchCase="'penalties'">
                      <img class="self-start mt-2" src="assets/images/penalties.svg" />
                      <div class="flex flex-col flex-1">
                        <details>
                          <summary style="list-style: none">
                            <span class="text-gray-600 leading-normal" style="font-size: 10px">PENALTIES</span>
                            <div class="cursor-pointer">
                              <span class="text-blue-500">{{ getPenaltyAlertTitleTrailerNumber(alert.title) }}</span>
                              {{ getPenaltyAlertTitle(alert.title) }}
                            </div>
                            <span class="text-gray-600 text-sm">{{ alert.createdAt | ago }}</span>
                          </summary>
                          <div class="mt-1 flex flex-col">
                            <div>
                              <span class="text-gray-600">
                                {{ getPenaltyAlertDescription(alert.description) }}
                              </span>
                              <span class="text-blue-500 cursor-pointer"
                                >{{ getPenaltyAlertDescriptionDriverNumber(alert.description) }}
                              </span>
                            </div>
                          </div>
                        </details>
                      </div>
                      <span
                        class="material-icons text-gray-600 text-lg mt-2 cursor-pointer"
                        *ngIf="!alert.dismissing; else dismissing"
                        (click)="alert.dismissing = true; dismissNotification([alert.id])"
                        >clear</span
                      >
                      <ng-template #dismissing>
                        <span class="mt-2">
                          <mat-spinner diameter="16" [color]="'primary'"></mat-spinner>
                        </span>
                      </ng-template>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #noAlerts>
              <div class="flex flex-col items-center h-full justify-center">
                <img class="mb-3 h-16" src="assets/images/no-alerts.svg" />
                <span class="mb-1 text-gray-900 text-lg">No Alerts!</span>
                <span class="text-gray-600 text-xs">Check back later for new alerts</span>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>

      <div class="flex flex-col mb-2">
        <span class="text-gray-900 text-xl font-bold mb-2">Activity Report</span>
        <div class="card-with-shadow flex flex-col bg-white rounded mb-3" style="max-height: 612px">
          <div class="w-full flex flex-col" *ngIf="fracsActivity$ | async as fracActivityReportPerRegions">
            <mat-form-field class="p-3">
              <mat-select [value]="selectedFracActivity$$ | async" (valueChange)="selectFracActivity($event)">
                <mat-option
                  [value]="region"
                  *ngFor="let region of fracActivityReportPerRegions; trackBy: 'id' | trackByKey"
                >
                  {{ region.regionName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div
              class="flex flex-col w-full overflow-auto"
              *ngIf="selectedFracActivity$$ | async as selectedFracActivity"
            >
              <div *ngIf="selectedFracActivity.fracsRunningToday?.length + selectedFracActivity.fracsDown?.length">
                <div class="flex flex-col mt-3 gap-y-2">
                  <div class="text-xl font-bold px-3">Loads Per Day</div>
                  <div class="flex flex-row w-full">
                    <div
                      class="p-2 w-1/2 flex flex-col items-center justify-center text-center border-t border-r border-b border-gray-400"
                    >
                      <div class="text-gray-500">High performing trucks could do:</div>
                      <div class="text-2xl font-bold mt-1">3 Loads</div>
                    </div>
                    <div
                      class="p-2 w-1/2 flex flex-col items-center justify-center text-center border-t border-b border-gray-400"
                    >
                      <div class="text-gray-500">The average turn rate is:</div>
                      <div class="text-2xl font-bold mt-1">
                        <ng-container *ngIf="selectedFracActivity.avgTurnRate > 0; else dash">
                          {{ selectedFracActivity.avgTurnRate | number: '1.0-1' }} Loads
                        </ng-container>
                        <ng-template #dash>-</ng-template>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col mt-3 gap-y-2 px-3 mb-3">
                  <div class="text-xl font-bold">Affecting Your Loads Per Day</div>
                  <div class="cursor-pointer" (click)="openCrewsModal()">
                    <span class="border-b border-black border-dotted">
                      Out of
                      {{ selectedFracActivity.fracsRunningToday?.length + selectedFracActivity.fracsDown?.length }}
                      crews pumping in the region:
                    </span>
                  </div>
                  <div class="flex flex flex-col">
                    <div class="flex flex-row" *ngIf="selectedFracActivity.fracsRunningToday?.length > 0">
                      <div class="mr-2">
                        <mat-icon> info_outline</mat-icon>
                      </div>
                      <div class="col-span-3">
                        {{ selectedFracActivity.fracsRunningToday?.length | number }} well
                        <ng-container *ngIf="selectedFracActivity.fracsRunningToday?.length > 1">s</ng-container>
                        running today
                      </div>
                    </div>
                    <div class="flex flex-row" *ngIf="selectedFracActivity.fracsPumpingSlower?.length > 0">
                      <div class="mr-2">
                        <mat-icon> info_outline</mat-icon>
                      </div>
                      <div class="col-span-3">
                        {{ selectedFracActivity.fracsPumpingSlower?.length | number }} well
                        <ng-container *ngIf="selectedFracActivity.fracsPumpingSlower?.length > 1">s</ng-container>
                        pumping slower than expected
                      </div>
                    </div>
                    <div class="flex flex-row" *ngIf="selectedFracActivity.fracsDown?.length > 1">
                      <div div class="mr-2">
                        <mat-icon> info_outline</mat-icon>
                      </div>
                      <div class="col-span-3">
                        {{ selectedFracActivity.fracsDown?.length | number }} well
                        <ng-container *ngIf="selectedFracActivity.fracsDown?.length > 1">s</ng-container>
                        down
                      </div>
                    </div>
                    <div class="flex flex-row" *ngIf="selectedFracActivity.fracsLongWaitTimes?.length > 0">
                      <div div class="mr-2">
                        <mat-icon> info_outline</mat-icon>
                      </div>
                      <div class="col-span-3">
                        {{ selectedFracActivity.fracsLongWaitTimes?.length | number }} well
                        <ng-container *ngIf="selectedFracActivity.fracsLongWaitTimes?.length > 1">s</ng-container>
                        with long wait times, currently
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-with-shadow flex flex-col bg-gray-600 rounded px-4 py-3 text-white relative mb-6">
        <span class="font-bold text-xl mb-1">We Value Your Feedback!</span>
        <span class="mb-2 text-sm" style="width: 190px"
          >Help us improve 5F. We want to provide you with the best experience possible.</span
        >
        <a
          class="flex flex-row cursor-pointer text-white items-center"
          target="_blank"
          href="https://5ff.typeform.com/to/IpMr68LL"
        >
          <span class="material-icons text-base mr-1">arrow_forward</span>
          Provide Feedback
        </a>
        <img src="assets/images/feedback.svg" alt="feedback" class="h-7 absolute bottom-0 right-0 mb-3 mr-4" />
      </div>
    </div>
  </div>
</div>
<ng-template #crewModal>
  <ng-container *ngIf="selectedFracActivity$$ | async as selectedFracActivity">
    <div mat-dialog-title>Crews in {{ selectedFracActivity.regionName }}</div>
    <div mat-dialog-content>
      <lohi-frac-activity-info
        class="flex-1"
        [fracStatus]="'running'"
        [title]="'Fracs Running Today'"
        [fracActivityInfo]="selectedFracActivity.fracsRunningToday"
      ></lohi-frac-activity-info>

      <lohi-frac-activity-info
        class="flex-1"
        [fracStatus]="'down'"
        [title]="'Fracs Down'"
        [fracActivityInfo]="selectedFracActivity.fracsDown"
      ></lohi-frac-activity-info>

      <lohi-frac-activity-info
        class="flex-1"
        [fracStatus]="'soon'"
        [title]="'Frac Starting Soon'"
        [fracActivityInfo]="selectedFracActivity.fracsStartingSoon"
      ></lohi-frac-activity-info>
    </div>
  </ng-container>
</ng-template>
